export default __webpack_public_path__ + "locales/sl/FormFillingTipsDialog.json?hash=65089ba90703c76e928227463e0785eb";